window.KlaiyiUtils = window.KlaiyiUtils || {};

(function ensureRequestIdleCallback() {
  if (typeof window.requestIdleCallback !== "function") {
    window.requestIdleCallback = function (cb, opts) {
      var start = Date.now();
      return setTimeout(function () {
        cb({
          didTimeout: false,
          timeRemaining: function () {
            return Math.max(0, 50 - (Date.now() - start));
          },
        });
      }, (opts && opts.timeout) || 1);
    };
  }
  if (typeof window.cancelIdleCallback !== "function") {
    window.cancelIdleCallback = function (id) {
      clearTimeout(id);
    };
  }
})();

/**
 * INP：先让浏览器完成点击后的首帧绘制，再执行埋点/次要逻辑（不影响 LCP/CLS）
 */
KlaiyiUtils.deferAfterInteraction = function (fn) {
  if (typeof fn !== "function") return;
  if (typeof requestAnimationFrame === "function") {
    requestAnimationFrame(function () {
      if (
        typeof scheduler !== "undefined" &&
        typeof scheduler.postTask === "function"
      ) {
        scheduler.postTask(fn, { priority: "background" });
      } else if (typeof window.requestIdleCallback === "function") {
        window.requestIdleCallback(fn, { timeout: 200 });
      } else {
        setTimeout(fn, 0);
      }
    });
  } else {
    setTimeout(fn, 0);
  }
};

/**
 * INP：合并全站 scroll 回调为单个 passive + rAF 节流监听，避免滚动时阻塞后续点击/触摸
 */
KlaiyiUtils.onScrollThrottled = function (fn) {
  if (typeof fn !== "function") return;
  KlaiyiUtils._scrollFns = KlaiyiUtils._scrollFns || new Set();
  if (KlaiyiUtils._scrollFns.has(fn)) return;
  KlaiyiUtils._scrollFns.add(fn);

  if (KlaiyiUtils._scrollBound) return;
  KlaiyiUtils._scrollBound = true;
  var ticking = false;
  window.addEventListener(
    "scroll",
    function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        KlaiyiUtils._scrollFns.forEach(function (cb) {
          try {
            cb();
          } catch (e) {
            console.warn("onScrollThrottled callback error", e);
          }
        });
      });
    },
    { passive: true }
  );
};

// 获取币种代码
KlaiyiUtils.getCurrencyCode = function () {
  return (
    window.Shopify?.currency?.active ||
    window.Currency?.currentCurrency ||
    window.Shopify?.currency?.current ||
    "USD"
  );
};

// 获取汇率
KlaiyiUtils.getCurrencyRate = function () {
  if (window.Shopify?.currency?.rate) {
    return Number(window.Shopify.currency.rate);
  }
  if (window.Currency?.rate) {
    return Number(window.Currency.rate);
  }
  return 1;
};

// 货币符号映射
KlaiyiUtils.CURRENCY_SYMBOL_MAP = {
  USD: "$",
  EUR: "€",
  GBP: "£",
  SGD: "S$",
  AUD: "A$",
  CAD: "C$",
  JPY: "¥",
  CNY: "¥",
  HKD: "HK$",
  TWD: "NT$",
  KRW: "₩",
  INR: "₹",
};

// 获取货币符号
KlaiyiUtils.getCurrencySymbol = function (currency) {
  if (!currency) currency = KlaiyiUtils.getCurrencyCode();
  return KlaiyiUtils.CURRENCY_SYMBOL_MAP[currency] || currency;
};

// 获取完整货币信息对象
KlaiyiUtils.getCurrencyInfo = function () {
  var currency = KlaiyiUtils.getCurrencyCode();
  var currency_rate = KlaiyiUtils.getCurrencyRate();
  var currency_symbol = KlaiyiUtils.getCurrencySymbol(currency);

  return {
    currency: currency,
    currency_symbol: currency_symbol,
    currency_rate: currency_rate,
  };
};

// 保留2位小数
KlaiyiUtils.ceilToTwo = function (num) {
  return (Math.ceil(num * 100) / 100).toFixed(2);
};
/**
 * 向上取 2 位小数（cents 级）
 */
KlaiyiUtils.ceilCents = function (cents) {
  return Math.ceil(cents / 1) || 0;
};
// 获取当前价格
KlaiyiUtils.getCentsFromEl = function ($el) {
  if (!$el || !$el.length) return 0;

  const cents = $el.data("cents");
  return !isNaN(cents) ? Number(cents) : 0;
};
KlaiyiUtils.setPriceEl = function ($el, cents) {
  if (!$el || !$el.length) return;

  cents = Number(cents) || 0;

  let moneyHtml = "";

  // ① Shopify 多币种 Currency
  if (window.Currency && typeof window.Currency.formatMoney === "function") {
    moneyHtml = window.Currency.formatMoney(cents, window.theme?.moneyFormat);
  }
  // ② Shopify 原生
  else if (window.Shopify && typeof Shopify.formatMoney === "function") {
    moneyHtml = Shopify.formatMoney(
      cents,
      window.theme?.moneyFormat || "${{amount}}"
    );
  } else {
    moneyHtml = (cents / 100).toFixed(2);
  }

  /**
   * ✅ 兜底：强制保留 2 位小数
   * - $20    → $20.00
   * - €18    → €18.00
   * - £9.5   → £9.50
   * - €96,07 → 已是 2 位小数，不处理
   */
  const hasTwoDecimals = /[.,]\d{2}(?!\d)/.test(moneyHtml);
  if (!hasTwoDecimals) {
    if (!/[.,]\d/.test(moneyHtml)) {
      moneyHtml = moneyHtml.replace(/(\d+)(?![\d.,])/, (match) => `${match}.00`);
    } else {
      moneyHtml = moneyHtml.replace(/([.,])(\d)(?!\d)/, (_, sep, digit) => `${sep}${digit}0`);
    }
  }

  // 支持传入多个价格节点（如 M 端快购顶部/底部各有一份克隆 DOM）
  $el.each(function () {
    const $container = $(this);
    let $target = $container;

    // 容器内含独立价格节点时，只更新价格节点，保留标签等结构
    if (!$target.is(".money") && !$target.is("strong")) {
      const $money = $target.find(".money").first();
      if ($money.length) {
        $target = $money;
      } else {
        const $strong = $target.children("strong").first();
        if ($strong.length) {
          $target = $strong;
        }
      }
    }

    $container.attr("data-cents", cents);
    $target.attr("data-cents", cents);

    const prefix = $target.attr("data-prefix") || "";
    $target.html(prefix + moneyHtml);
  });
};

// 修复一口价弹窗在属性切换后被 setPriceEl 破坏的 DOM 结构
KlaiyiUtils.restoreExclusivePopupStructure = function ($wrapper) {
  const $topWord = $wrapper.find(".best-exclusive-popup-cen-top-word");
  if ($topWord.length && !$topWord.find(".money").length) {
    $topWord.html(
      '<span>Estimated price</span><p><span class="money"></span></p>'
    );
  }

  const labeledItems = [
    [".price-item-now", "Original price"],
    [".price-item-old", "Item Discount"],
  ];

  labeledItems.forEach(function (pair) {
    const $item = $wrapper.find(pair[0]);
    if ($item.length && !$item.find("strong").length) {
      $item.html("<strong></strong><br>" + pair[1]);
    }
  });

  const $save = $wrapper.find(".price-item-save");
  if ($save.length && !$save.find(".price-item-green-out").length) {
    const codeText = ($wrapper.find(".buy_out_code").text() || "")
      .replace(/^code:\s*/i, "")
      .trim();
    $save.html(
      "<strong></strong><br>" +
        '<div class="price-item-green-out">' +
        '<span class="green">Code:</span> <span class="kuang_code green">' +
        codeText +
        "</span></div>"
    );
  }
};

// 全局方法：更新 buyout 区域价格信息（支持产品页 + 快速加购）
KlaiyiUtils.updateBuyoutPriceInfo = function (container = $(document)) {
  const ceilToTwo = KlaiyiUtils.ceilToTwo;

  container.find(".Product__Wrapper").each(function () {
    const $wrapper = $(this);

    KlaiyiUtils.restoreExclusivePopupStructure($wrapper);

    // ===== 读取基础数据（全部 cents）=====
    const priceCents = KlaiyiUtils.getCentsFromEl(
      $wrapper.find(".Price--highlight").first()
    );

    const compareAtCents = KlaiyiUtils.getCentsFromEl(
      $wrapper.find(".Price--compareAt").first()
    );

    const quantity =
      parseInt($wrapper.find(".QuantitySelector__CurrentQuantity").val(), 10) ||
      1;
    console.log("价格更新", quantity);
    const discountValue =
      parseFloat($wrapper.find(".product_xinzheng_discount").first().text()) ||
      0;

    const discountType = $wrapper.find(".discount_type").text().trim();

    // ===== 计算单件一口价（cents）=====
    let singleCents = priceCents;
    console.log("一口价的价格", singleCents);
    if (discountType === "1") {
      // 百分比
      singleCents = Math.ceil(priceCents * (1 - discountValue / 100));
      console.log("一口价百分比的价格", singleCents);
    } else if (discountType === "2") {
      // 直减
      singleCents = Math.max(priceCents - Math.round(discountValue * 100), 0);
      console.log("一口价满减的价格", singleCents);
    }

    // ===== 数量后的价格 =====
    const totalNowCents = priceCents * quantity;
    const totalCompareAtCents = compareAtCents * quantity;
    const totalBuyoutCents = singleCents * quantity;
    const saveCents = Math.max(totalCompareAtCents - totalNowCents, 0);

    // ===== 产品区价格 =====
    KlaiyiUtils.setPriceEl(
      $wrapper.find(".buy_btn_save .Price--highlight"),
      totalNowCents
    );

    if (compareAtCents > 0) {
      KlaiyiUtils.setPriceEl(
        $wrapper.find(".buy_btn_save .Price--compareAt"),
        totalCompareAtCents
      );

      KlaiyiUtils.setPriceEl(
        $wrapper.find(".buy_btn_save .save2 .money"),
        saveCents
      );

      KlaiyiUtils.setPriceEl(
        $wrapper.find(".price-item-now"),
        totalCompareAtCents
      );

      KlaiyiUtils.setPriceEl($wrapper.find(".price-item-old"), saveCents);

      KlaiyiUtils.setPriceEl(
        $wrapper.find(".price-item-save"),
        totalBuyoutCents > 0
          ? totalCompareAtCents - totalBuyoutCents
          : saveCents
      );
    } else {
      KlaiyiUtils.setPriceEl($wrapper.find(".price-item-now"), totalNowCents);

      KlaiyiUtils.setPriceEl(
        $wrapper.find(".price-item-save"),
        totalNowCents - totalBuyoutCents
      );
    }

    // ===== 一口价区域 =====
    if ($wrapper.find(".buy_btn_save .buyout_out").length > 0) {
      KlaiyiUtils.setPriceEl(
        $wrapper.find(".buyout_out .buyout_price"),
        singleCents
      );

      KlaiyiUtils.setPriceEl(
        $wrapper.find(".buy_btn_save .buyout_price"),
        totalBuyoutCents
      );

      KlaiyiUtils.setPriceEl(
        $wrapper.find(".best-exclusive-popup-cen-top-word"),
        totalBuyoutCents
      );

      $wrapper.find(".buyout_out").removeClass("none");
      $wrapper.find(".save2").hide();

      $wrapper
        .find(".buy_out_codeNum")
        .text($wrapper.find(".discount_bar_cen_right span").text());
    }
  });
};

// ===== 在命名空间内部维护缓存 =====
KlaiyiUtils._stockCache = KlaiyiUtils._stockCache || {};

// ===== 获取库存 =====
KlaiyiUtils.fetchVariantStock = function (variantId) {
  return new Promise((resolve) => {
    if (!variantId) {
      resolve(0);
      return;
    }

    // 如果缓存存在，直接返回
    if (KlaiyiUtils._stockCache[variantId] !== undefined) {
      resolve(KlaiyiUtils._stockCache[variantId]);
      return;
    }

    $.ajax({
      url: `${window.API_BASE}/api/klaiyi/variant_quantity`,
      method: "GET",
      data: { variant_id: variantId },
      headers: {
        Authorization: "Bearer 6JXquydq6hZG4aJyN8A5",
      },
      success: function (res) {
        let stock = 0;

        // ✅ 新接口成功判断
        if (res.code === 200000 && res.data) {
          try {
            const edges =
              res.data.data.productVariant.inventoryItem.inventoryLevels.edges;

            if (edges && edges.length > 0) {
              const quantities = edges[0].node.quantities;

              if (quantities && quantities.length > 0) {
                stock = Number(quantities[0].quantity || 0);
              }
            }
          } catch (e) {
            console.warn("库存解析失败", e);
            stock = 0;
          }
        }
        // console.log("真实库存:", stock);
        // 存入缓存
        KlaiyiUtils._stockCache[variantId] = stock;

        resolve(stock);
      },
      error: function () {
        resolve(0);
      },
    });
  });
};
// 更新购物车总数量
KlaiyiUtils.updateCartTotal = function () {
  const cartItems = document.querySelectorAll(".CartItem");
  let totalQuantity = 0;

  cartItems.forEach((item) => {
    const input = item.querySelector(".QuantitySelector__CurrentQuantity");
    if (!input) return;
    totalQuantity += parseInt(input.value, 10) || 0;
  });

  const totalEl = document.querySelector(".Cart__Total_title_left");
  if (totalEl) {
    totalEl.textContent = `${totalQuantity} Items`;
  }
};
// 显示提示函数
window.utils = window.utils || {};

window.utils.showCopyTip = function (message, options = {}) {
  const duration = options.duration || 1500;
  const type = options.type || "success"; // success | error

  const tip = document.createElement("div");
  /* ✅ 新增 class */
  tip.className = `copy-tip copy-tip--${type}`;
  /* 容器样式 */
  Object.assign(tip.style, {
    position: "fixed",
    top: "50%",
    left: "50%",
    transform: "translateX(-50%)",
    background: "rgba(0,0,0,0.7)",
    color: "#fff",
    padding: "14px 16px",
    borderRadius: "8px",
    zIndex: "9999",
    fontSize: "14px",
    opacity: "0",
    transition: "opacity 0.3s",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    gap: "6px",
    whiteSpace: "nowrap",
  });

  /* SVG 图标 */
  const icon = document.createElement("span");
  icon.className = `copy-tip-icon copy-tip-icon--${type}`;
  icon.innerHTML =
    type === "success"
      ? `
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M9.99984 18.3333C14.6022 18.3333 18.3332 14.6023 18.3332 9.99996C18.3332 5.39759 14.6022 1.66663 9.99984 1.66663C5.39746 1.66663 1.6665 5.39759 1.6665 9.99996C1.6665 14.6023 5.39746 18.3333 9.99984 18.3333ZM12.4746 7.47468C12.7186 7.23061 13.1144 7.23061 13.3584 7.47468C13.6025 7.71876 13.6025 8.11449 13.3584 8.35857L9.19178 12.5252C8.9477 12.7693 8.55197 12.7693 8.3079 12.5252L6.64123 10.8586C6.39715 10.6145 6.39715 10.2188 6.64123 9.97468C6.88531 9.73061 7.28103 9.73061 7.52511 9.97468L8.74984 11.1994L12.4746 7.47468Z" fill="#00CC13"/>
      </svg>
    `
      : `
      <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M8.33333 16.6667C12.9357 16.6667 16.6667 12.9357 16.6667 8.33333C16.6667 3.73096 12.9357 0 8.33333 0C3.73096 0 0 3.73096 0 8.33333C0 12.9357 3.73096 16.6667 8.33333 16.6667ZM5.80802 6.69192C5.56395 6.44785 5.56395 6.05212 5.80802 5.80804C6.0521 5.56396 6.44783 5.56396 6.69191 5.80804L8.33331 7.44944L9.97469 5.80806C10.2188 5.56398 10.6145 5.56398 10.8586 5.80806C11.1027 6.05214 11.1027 6.44786 10.8586 6.69194L9.21719 8.33333L10.8586 9.97469C11.1026 10.2188 11.1026 10.6145 10.8586 10.8586C10.6145 11.1027 10.2188 11.1027 9.97467 10.8586L8.33331 9.21721L6.69192 10.8586C6.44785 11.1027 6.05212 11.1027 5.80804 10.8586C5.56396 10.6145 5.56396 10.2188 5.80804 9.97471L7.44942 8.33333L5.80802 6.69192Z" fill="#FF4F5A"/>
      </svg>
    `;

  /* 文案 */
  const text = document.createElement("span");
  text.textContent = message;
  text.style.color = "#fff";
  tip.appendChild(icon);
  tip.appendChild(text);
  document.body.appendChild(tip);

  /* 显示动画 */
  requestAnimationFrame(() => {
    tip.style.opacity = "1";
  });

  /* 隐藏 & 销毁 */
  setTimeout(() => {
    tip.style.opacity = "0";
    tip.addEventListener(
      "transitionend",
      () => {
        tip.remove();
      },
      { once: true }
    );
  }, duration);
};

window.utils.getRouteName = function () {
  const $body = jQuery("body");

  if ($body.hasClass("template-index")) {
    return "HomePage";
  }

  if ($body.hasClass("template-search")) {
    return "search";
  }

  if (jQuery(".PageOverlay").hasClass("is-visible")) {
    return "search";
  }

  if ($body.hasClass("template-collection")) {
    return "productList";
  }

  if ($body.hasClass("template-product")) {
    return "productDetail";
  }

  if ($body.hasClass("template-cart")) {
    return "cartCheckout";
  }

  if (
    $body.hasClass("template-customers-register") ||
    $body.hasClass("template-customers-login")
  ) {
    return "Signup/Login";
  }

  if ($body.hasClass("template-account")) {
    return "My Account";
  }

  /** =========================
   * otherPage：返回完整路由（不含域名）
   * ========================= */
  const pathname = window.location.pathname; // /pages/buy-1-get-1-free

  // 去掉开头的 /
  const route = pathname.replace(/^\/+/, "");

  return route || "otherPage";
};

// 小图切换大图（详情，快速加购)
(function (window, $) {
  var itemHeight = 114;
  var visibleCount = 4;

  var currentStart = 0;
  var maxStart = 0;
  var $scroller = null;

  // 👉 初始化（页面必须先调用）
  window.initProductNavScrollerBase = function (options) {
    options = options || {};

    itemHeight = options.itemHeight || 114;
    visibleCount = options.visibleCount || 4;

    $scroller = $(options.scroller || ".Product__SlideshowNavScroller");

    var total = $(options.item || ".Product__SlideshowNavImage").length;
    maxStart = Math.max(0, total - visibleCount);

    currentStart = 0;
  };

  // 👉 核心滚动方法（给外部用）
  window.scrollProductNavTo = function (start) {
    if (!$scroller || !$scroller.length) return;

    start = Math.max(0, Math.min(start, maxStart));
    currentStart = start;

    var top = -(start * itemHeight);

    $scroller.stop().animate({ top: top }, 200);

    // 如果你有这个方法就保留
    if (typeof updateArrowState === "function") {
      updateArrowState(currentStart, maxStart);
    }
  };

  /**
   * 将第 navIndex 个缩略图滚到 .product_thumbnail-out 可视区域垂直方向大致居中
   * @param {number} navIndex 当前选中缩略图下标（0-based）
   * @param {Element} [activeEl] 选中项 DOM，用于定位 Scroller 与测量每项高度
   */
  window.scrollProductNavToCenterNavIndex = function (navIndex, activeEl) {
    if (navIndex == null || navIndex < 0 || isNaN(navIndex)) return;

    var $scr = null;
    if (activeEl && activeEl.nodeType) {
      $scr = $(activeEl).closest(".Product__SlideshowNavScroller");
    }
    if (!$scr || !$scr.length) {
      $scr = $scroller && $scroller.length ? $scroller : $(".Product__SlideshowNavScroller").first();
    }
    if (!$scr || !$scr.length) return;

    var $items = $scr.find(".Product__SlideshowNavImage");
    if (!$items.length) return;
    var total = $items.length;
    if (navIndex >= total) return;

    var $out = $scr.closest(".product_thumbnail-out");
    if (!$out.length) {
      $out = $scr.closest(".product_thumbnail");
    }
    var outH =
      ($out.length && $out[0].clientHeight) ||
      ($scr.parent().length && $scr.parent()[0].clientHeight) ||
      0;

    var first = $items[0];
    var second = $items[1];
    var step = itemHeight;
    if (second) {
      var d = second.offsetTop - first.offsetTop;
      if (d > 10) step = d;
    } else {
      var oh = $(first).outerHeight(true);
      if (oh > 10) step = oh;
    }

    var visibleInView = Math.max(
      1,
      Math.floor((outH > 0 ? outH : step * visibleCount) / step)
    );
    var maxS = Math.max(0, total - visibleInView);
    var start = navIndex - Math.floor(visibleInView / 2);
    start = Math.max(0, Math.min(start, maxS));

    currentStart = start;
    maxStart = maxS;
    visibleCount = visibleInView;
    itemHeight = step;
    if (!$scroller || !$scroller.length || $scroller[0] !== $scr[0]) {
      $scroller = $scr;
    }

    var topPx = -(start * step);
    $scr.stop().animate({ top: topPx }, 200);

    if (typeof updateArrowState === "function") {
      updateArrowState(currentStart, maxStart);
    }
  };

  // 👉 给外部获取当前状态（可选）
  window.getProductNavState = function () {
    return {
      currentStart: currentStart,
      maxStart: maxStart,
      visibleCount: visibleCount,
    };
  };
})(window, jQuery);
